import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ajax } from '../../utils/web/webUtils.js';
import { createAlert } from '../standaloneComponents.js';
import Login from '../login/login.js';
import Loading from '../loading/loading.js';
import './loginProvider.scss';
export var LoginContext = /*#__PURE__*/createContext({
  loggedIn: null,
  logInWindowOpen: false,
  user: null
});

function LoginProvider(props) {
  var {
    children,
    requireLogin = true
  } = props;
  var [loggedIn, setLoggedIn] = useState(null);
  var [logInWindowOpen, setLogInWindowOpen] = useState(false);
  var [user, setUser] = useState(null);
  var navigate = useNavigate();
  useEffect(() => {
    if (requireLogin) {
      ajax({
        endPoint: '/checkLoggedIn'
      }).then(results => {
        if (!results.result && window.location.pathname !== '/') {
          navigate('/');
        }

        setLoggedIn(results.result);
        setUser(results.user);
      });
    }
  }, []);

  var login = async (username, password) => {
    var results = await ajax({
      endPoint: '/login',
      data: {
        username,
        password
      }
    });

    if (!results.result) {
      createAlert(results.desc);
    }

    setLoggedIn(results.result);
    setUser(results.user);

    if (logInWindowOpen) {
      setLogInWindowOpen(false);
    }
  };

  var logout = async () => {
    var results = await ajax({
      endPoint: '/logout'
    });

    if (results.result) {
      navigate('/');
    }

    setLoggedIn(!results.result);
    setUser(null);
  };

  var showLogInWindow = () => setLogInWindowOpen(true);

  if (requireLogin && loggedIn === null) {
    return /*#__PURE__*/React.createElement(Loading, {
      type: "fixed"
    });
  } else if (requireLogin && !loggedIn) {
    return /*#__PURE__*/React.createElement(Login, {
      login: login
    });
  } else {
    return /*#__PURE__*/React.createElement(LoginContext.Provider, {
      value: {
        login,
        logout,
        loggedIn,
        logInWindowOpen,
        setLogInWindowOpen,
        user,
        showLogInWindow
      }
    }, children);
  }
}

export default LoginProvider;